import { Link } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/joy';
import { X } from '@phosphor-icons/react';

import i18n from '@/i18n';

export function NotAuthorizedPage() {
    return (
        <Box sx={{ position: 'fixed', left: 0, top: 0, gap: 1, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <X size={128} />
            <Typography level="h1" element="h1">{i18n.t('not-belongs-to-label-page.heading')}</Typography>
            <Typography>{i18n.t('not-belongs-to-label-page.text')}</Typography>
            <Button aria-label="Log out" variant="solid" as={Link} to="/accounts/logout">Log out</Button>
        </Box>
    )
}
